module.exports = __webpack_public_path__ + "static/02-568b8cfd7fd96af7f71441adb2e7c6b7.jpg";